import React from 'react';
import { Grid, Typography, FormControlLabel, Radio, RadioGroup } from '@material-ui/core';

const SmsConsent = ({ values, handleChange }) => {
  return (
    <>
      <Grid item sm={12} xs={12} md={12}  lg={12}>
        <Typography variant='body2'>Do you consent to receive SMS notifications?</Typography>
        <RadioGroup row aria-label="agreed_sms" name="agreed_sms" value={values.agreed_sms} onChange={handleChange}>
          <FormControlLabel value="Y" control={<Radio />} label="Yes" />
          <FormControlLabel value="N" control={<Radio />} label="No" />
        </RadioGroup>
      </Grid>
    </>
  );
}

export { SmsConsent };
